import { useSearchParams } from "react-router-dom"

export function useNavigation() {
  const [searchParams, setSearchParams] = useSearchParams()

  return {
    searchParams,
    setSearchParams,
  }
}